import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var EyeDropperIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("g", {
                            clipPath: "url(#clip0_425_21325)",
                            children: _jsx("path", {
                                d: "M21.044 3.059c-1.413-1.412-3.648-1.412-4.942 0l-2.471 2.47-1.295-1.294a.569.569 0 00-.823 0L9.748 6a.569.569 0 000 .824l1.294 1.294L3.159 16l-1.06 3.294C1.638 20.683 2.865 22 4.219 22c1.216 0 2.59-.637 3.765-.941l7.883-7.883 1.295 1.295a.569.569 0 00.823 0l1.765-1.765a.569.569 0 000-.824l-1.294-1.294 2.47-2.47a3.662 3.662 0 00.119-5.06zM6.806 18.94l-2.235.588.588-2.235 7.413-7.412 1.647 1.647-7.413 7.412z"
                            })
                        }),
                        _jsx("defs", {
                            children: _jsx("clipPath", {
                                id: "clip0_425_21325",
                                children: _jsx("path", {
                                    d: "M0 0h24v24H0z"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
EyeDropperIcon.isCarinaIcon = true;
export default EyeDropperIcon;
